module.exports = __webpack_public_path__ + "img/copy.91ca5390.svg";